module.exports = __webpack_public_path__ + "static/media/8.c7f78c54.jpg";